'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VerticalMenu = require('./VerticalMenu');

var _VerticalMenu2 = _interopRequireDefault(_VerticalMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _VerticalMenu2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_bee-menus@1.0.7@bee-menus/build/index.js
// module id = 100
// module chunks = 0